<div class="card flex justify-content-center" style="min-height: 700px;overflow: auto;margin-top: 30px;width: 100%;">
    <p-organizationChart [value]="hierarchicalData"></p-organizationChart>
</div>